import { QuoteRoutes } from '../../../main/constants'
import { StatsQuery } from '../../stats/types'
import { useChartTimeframePathWatch } from '../use-chart-timeframe-path-watch'

const originalElement = document.querySelector<HTMLAnchorElement>('.js-financials-link a')

export default function FinancialsLink() {
  const currentTimeframePath = useChartTimeframePathWatch()
  if (!currentTimeframePath)
    return (
      <a href={originalElement?.href} className={originalElement?.className}>
        Financials
      </a>
    )

  const newURL = new URL(currentTimeframePath, window.location.origin)
  newURL.searchParams.set(StatsQuery.ChartType, QuoteRoutes.Dividends)

  return (
    <a href={`${newURL.pathname}${newURL.search}`} className="tab-link">
      Financials
    </a>
  )
}
